import { isFilterValueHasRestrictedPropertiesUsingRestrictedValueCheck } from 'customer-data-filters-ui/utils/fieldLevelPermissions';
import { useContext } from 'react';
import RestrictedFiltersViewState from 'customer-data-filters-ui/components/common/RestrictedFiltersViewState';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import FiltersDisplayViewer from '../viewer/FiltersDisplayViewer';
import UIBox from 'UIComponents/layout/UIBox';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const FiltersDisplayUI = () => {
  const {
    props: {
      value,
      uiMessages: {
        restrictedFiltersMessage
      }
    }
  } = useContext(SegmentationFiltersInstanceContext);
  if (isFilterValueHasRestrictedPropertiesUsingRestrictedValueCheck(value)) {
    return /*#__PURE__*/_jsx(RestrictedFiltersViewState, {
      message: restrictedFiltersMessage
    });
  }
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "stretch",
    blockSize: "100%",
    display: "inline-flex",
    inlineSize: "auto",
    overflowY: "auto",
    children: /*#__PURE__*/_jsx(UIBox, {
      basis: 400,
      children: /*#__PURE__*/_jsx(FiltersDisplayViewer, {})
    })
  });
};
export default FiltersDisplayUI;